import { useContext } from 'react'
import { MemberContext } from './MemberContext'

/**
 * Хук для получения данных о пользователе из контекста
 * @returns {import('../type/member.type').MemberContextType} Данные пользователя
 */
export const useMember = () => {
  return useContext(MemberContext)
}
